import { render, staticRenderFns } from "./sectionsEvent.vue?vue&type=template&id=70f82bef&scoped=true"
import script from "./sectionsEvent.vue?vue&type=script&lang=js"
export * from "./sectionsEvent.vue?vue&type=script&lang=js"
import style0 from "./sectionsEvent.vue?vue&type=style&index=0&id=70f82bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f82bef",
  null
  
)

export default component.exports